import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { XCircle, ArrowLeft, RefreshCw } from "lucide-react";

const PaymentFailure = () => {
  const [searchParams] = useSearchParams();
  const invoiceId = searchParams.get("invoice_id");

  return (
    <div className="min-h-screen bg-muted/30 flex items-center justify-center px-4">
      <Card className="bg-white max-w-md w-full">
        <CardContent className="p-8 text-center">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-10 h-10 text-red-600" />
          </div>
          <h1 className="text-2xl font-bold text-foreground mb-2">Payment Cancelled</h1>
          <p className="text-muted-foreground mb-6">
            Your payment was not completed. No charges have been made.
          </p>

          <div className="space-y-3">
            {invoiceId && (
              <Button asChild className="w-full">
                <Link to={`/invoice/view/${invoiceId}`}>
                  <RefreshCw className="w-4 h-4 mr-2" />
                  Try Again
                </Link>
              </Button>
            )}
            <Button variant="outline" asChild className="w-full">
              <Link to="/">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Back to Billuna
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentFailure;
